export default __webpack_public_path__ + "static/lets-35460ba364723fa3d5f664c5762b5c4f.png";